import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { NotificationType } from '../../../enums';
import { useStore } from '../../../hooks';

import './style.scss';

/**
 * @description single toaster slot for the whole app. `toastNotificationStore` owns the queue and the
 * display/gap timing, so this only mirrors its `activeNotification`. The last item stays mounted after
 * the store cleared it — only the `show` class drops — otherwise the slide-out transition never plays.
 */
export const Notification: React.FC = observer(() => {

  const { toastNotificationStore } = useStore();
  const { activeNotification } = toastNotificationStore;

  const [lastNotification, setLastNotification] = useState(activeNotification);

  useEffect(() => {
    if (!activeNotification) return;
    setLastNotification(activeNotification);
  }, [activeNotification]);

  const handleClose = useCallback(() => {
    toastNotificationStore.hideActiveNotification();
  }, [toastNotificationStore]);

  if (!lastNotification) return null;

  const type = lastNotification.data || NotificationType.Success;

  return (
    <div className={`notification-wrp ${type} ${activeNotification ? 'show' : ''}`}>
      <p className="notification-txt">{lastNotification.message}</p>
      <button type="button" className="notification-close-button" onClick={handleClose}>
        <i className="icon-close notification-close-icon" />
      </button>
    </div>
  );
});
